require('./helpers/bundle-manifest').register(JSON.parse("{\"4pNqu\":\"index.c9122687.js\",\"iUXt4\":\"splide.esm.4897e930.js\"}"));